/** Find a product in the catalog object by category slug + external id. */
export function findProductInCatalog(products, categorySlug, productId) {
  const cat = String(categorySlug || '').trim();
  const id = String(productId || '').trim();
  if (!cat || !id) return null;
  const list = products?.[cat];
  if (!Array.isArray(list)) return null;
  const hit = list.find((p) => String(p?.id || '').trim() === id);
  if (!hit) return null;
  return { ...hit, category: cat };
}
